import { Instance, types } from 'mobx-state-tree'

export const VehicleRULModel = types.model('VehicleRULModel', {
    id: types.identifierNumber,
    remaining_days: types.maybeNull(types.number),
    remaining_flights: types.maybeNull(types.number),
    remaining_flight_seconds: types.maybeNull(types.number),
})
.views((self) => ({
    get remainingDays(): number | null {
        return self.remaining_days != null ? Math.max(0, self.remaining_days) : null
    },
    get remainingFlights(): number | null {
        return self.remaining_flights != null ? Math.max(0, self.remaining_flights) : null
    },
    get remainingFlightHours(): number | null {
        return self.remaining_flight_seconds != null ? Number((Math.max(0, self.remaining_flight_seconds) / 3600).toFixed(1)) : null
    },
}))

export type VehicleRUL = Instance<typeof VehicleRULModel>
